import { gql } from "@apollo/client";

export const INSERT_PAYOUT_ADJUSTMENT = gql`
  mutation insert_payout_adjustment($object: vendor_payout_adjustments_insert_input!) {
    insert_vendor_payout_adjustments_one(object: $object) {
      id
      vendor_id
      event_id
      kind
      amount
      description
      created_at
    }
  }
`;

export const DELETE_PAYOUT_ADJUSTMENT = gql`
  mutation delete_payout_adjustment($id: bigint!) {
    delete_vendor_payout_adjustments_by_pk(id: $id) {
      id
    }
  }
`;
